import { createFileRoute } from '@tanstack/react-router'

import Breadcrumbs from '@/containers/breadcrumbs'

import Content from '@/components/content'
import PageHeader from '@/components/pageHeader'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import PlaygroundNavigation from '../-components/playgroundNavigation'

export const Route = createFileRoute('/_authed/$client_code/playground/icons/')({
    component: PlaygroundIcons,
})

function PlaygroundIcons() {
    const { client_code } = Route.useParams()
    useSetBreadcrumbs([
        {
            to: '/$client_code/playground',
            text: 'Playground',
            params: { client_code },
        },
        'seperator',
        {
            to: '/$client_code/playground/icons',
            text: 'Icons',
            params: { client_code },
        },
    ])

    return (
        <>
            <Breadcrumbs />
            <Content>
                <PageHeader title="Icons" />
                <PlaygroundNavigation active="icons" />

                <p className="mt-4">
                    All our icons are available via{' '}
                    <a className="text-primary" target="_blank" href="https://lucide.dev/icons/">
                        Lucide
                    </a>
                </p>
            </Content>
        </>
    )
}
